export const MCU1_DEVICE_TYPE = 0;
export const MCU2_DEVICE_TYPE = 1;

export function isWiredFirmwareConnection(connectionType) {
  return connectionType === 'wired';
}

export function formatFirmwareVersion(version) {
  if (version == null || version === '') {
    return '--';
  }
  const normalizedVersion = Number(version);
  if (
    !Number.isInteger(normalizedVersion) ||
    normalizedVersion < 0 ||
    normalizedVersion > 0xffff
  ) {
    return '--';
  }

  const major = (normalizedVersion >> 8) & 0xff;
  const minor = (normalizedVersion >> 4) & 0x0f;
  const patch = normalizedVersion & 0x0f;
  return `${major}.${minor}.${patch}`;
}

export function getLatestFirmwareVersion(firmware) {
  if (!firmware?.header) {
    return null;
  }

  const versions = [
    firmware.header.app_version,
    firmware.header.APP2_version,
  ].filter(
    (version) =>
      Number.isInteger(version) && version >= 0 && version <= 0xffff
  );

  return versions.length > 0 ? Math.max(...versions) : null;
}

export function isFirmwareUpdateAvailable(currentVersion, firmware) {
  const latestVersion = getLatestFirmwareVersion(firmware);
  return (
    Number.isInteger(currentVersion) &&
    currentVersion >= 0 &&
    currentVersion <= 0xffff &&
    latestVersion != null &&
    currentVersion < latestVersion
  );
}

export function isFirmwareAtLatestVersion(currentVersion, firmware) {
  const latestVersion = getLatestFirmwareVersion(firmware);
  return (
    Number.isInteger(currentVersion) &&
    currentVersion >= 0 &&
    currentVersion <= 0xffff &&
    latestVersion != null &&
    currentVersion === latestVersion
  );
}

export function createFirmwareUpgradePlan({
  hasMcu2,
  mcu1Firmware,
  mcu2Firmware,
}) {
  if (!mcu1Firmware) {
    throw new Error('MCU1 固件尚未加载');
  }
  if (hasMcu2 && !mcu2Firmware) {
    throw new Error('MCU2 固件尚未加载');
  }

  return [
    ...(hasMcu2
      ? [
          {
            key: 'mcu2',
            label: 'MCU2',
            deviceType: MCU2_DEVICE_TYPE,
            firmware: mcu2Firmware,
          },
        ]
      : []),
    {
      key: 'mcu1',
      label: 'MCU1',
      deviceType: MCU1_DEVICE_TYPE,
      firmware: mcu1Firmware,
    },
  ];
}
